import { db, messaging } from './firebase';

// User API

export const doCreateUser = (id, username, email) =>
  db.ref(`admin/${id}`).set({
    username,
    email,
  });
export const updateDriver = (id, verify) =>
  db.ref(`drivers/${id}/verified`).set(
    verify
  );

// export const getDriver = (option, callback) =>
//   db.ref("drivers").orderByChild('verified').equalTo(option).on('child_changed', callback);
export const getConfig = (option, callback) => {
  db.ref('admin/config').on(option, callback);
}
export const getRecord = (ref, callback) => {
  db.ref(ref).on("value", callback);
}
export const getOnce = (ref) => {
  return db.ref(ref).once("value");
}
export const getTrips = (option, callback) => {
  db.ref('trips').on(option, callback);
}
export const updateConfigWithKey = (key, amount) =>
  db.ref("admin/config" + key).set(amount);

export const getUser = (option, callback) => {
  db.ref('users').orderByChild("joinDate").on(option, callback);
}
export const getDriver = (option, callback) => {
  db.ref("drivers").orderByChild("joinDate").on(option, callback);
}
export const updateDriverById = (id, document, field, option) => {
  return db.ref(`drivers/${id}/${document}/${field}`).set(option)
}
export const writeData = (ref, value, option) => {
  if (option) {
    return db.ref(ref).push(value);
  } else {
    return db.ref(ref).set(value);
  }
}
export const deleteDriver = (id) =>
  db.ref(`drivers/${id}`).remove();

export const deleteUser = (id) =>
  db.ref(`users/${id}`).remove();


messaging.requestPermission().then(function () {
  console.log('Notification permission granted.');
  getToken();
}).catch(function (err) {
  console.log('Unable to get permission to notify.', err);
});
const getToken = () => {
  messaging.getToken().then(function (currentToken) {
    if (currentToken) {
      updateConfigWithKey("/token", currentToken);
    } else {
      // Show permission request.
      console.log('No Instance ID token available. Request permission to generate one.');
      // Show permission UI.
    }
  }).catch(function (err) {
    console.log('An error occurred while retrieving token. ', err);
  });
}


// WEBPACK FOOTER //
// ./src/firebase/db.js